import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ANALYTICS_EVENTS } from '@neke/core';
import { track } from '../analytics';
import { Icon, Ornament } from '../components/Icon';
import type { IconName } from '../components/Icon';

/* Порядок плиток задаёт и порядок иконок — держим их одним списком,
   чтобы нельзя было добавить плитку и забыть знак. */
const TILES: ReadonlyArray<{ key: string; icon: IconName }> = [
  { key: 'spheres', icon: 'spheres' },
  { key: 'differences', icon: 'differences' },
  { key: 'map', icon: 'map' },
  { key: 'privacy', icon: 'privacy' },
];

export function Landing() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="hero">
        <Ornament />
      </div>

      <div className="stack">
        <h1>
          {t('landing.titleA')} <span className="gold">{t('landing.titleAccent')}</span>{' '}
          {t('landing.titleB')}
        </h1>
        <p className="muted">{t('landing.lead')}</p>
      </div>

      <div className="stack">
        <Link
          to="/test"
          className="btn btn-primary"
          onClick={() => void track(ANALYTICS_EVENTS.landingCtaClicked, { target: 'test' })}
        >
          {t('landing.cta')}
          <Icon name="arrow" size={18} />
        </Link>
        <Link
          to="/how"
          className="btn btn-ghost"
          onClick={() => void track(ANALYTICS_EVENTS.landingCtaClicked, { target: 'how' })}
        >
          <Icon name="play" size={16} />
          {t('landing.how')}
        </Link>
      </div>

      <div className="divider" aria-hidden="true">
        <Icon name="diamond" size={11} />
      </div>

      <div className="tiles">
        {TILES.map(({ key, icon }) => (
          <div className="tile" key={key}>
            <span className="tile-icon">
              <Icon name={icon} size={18} />
            </span>
            <span>
              <b>{t(`landing.tiles.${key}.title`)}</b>
              <span className="fine">{t(`landing.tiles.${key}.text`)}</span>
            </span>
          </div>
        ))}
      </div>

      <div className="landing-foot">
        <p className="eyebrow">{t('landing.values')}</p>
        <p className="fine">{t('brand.tagline')}</p>
      </div>
    </div>
  );
}
